<!--Load the font icons package:-->
<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<!-- <form [formGroup]="form" (ngSubmit)="onSaveAction()" class="k-form-inline"> -->
<kendo-expansionpanel title="Search" subtitle="Search on more constraints">

  <form [formGroup]="form" class="k-form-inline">

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="searchStr">Search String</label>
      <div class="col-8">
        <input type="text" id="searchStr" formControlName="searchStr" class="form-control">
      </div>
    </div>

    @if(!showProjects) {
    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="dashboardStr">Dashboard String</label>
      <div class="col-8">
        <input type="text" id="dashboardStr" formControlName="dashboardStr" class="form-control" [readOnly]="true">
      </div>
    </div>
    }

    @if(showProjects) {
    <div class="row">
      <div class="col-6">
        <div class="k-form-field">
          <label for="project_name" class="form-label col-3">Project</label>
          <div class="col-8">
            <kendo-dropdownlist class="ddl" id="project_name" #project_name [data]="projects"
              formControlName="projectId" textField="project_name" valueField="id" [defaultItem]="defaultProjectItem"
              [valuePrimitive]="true" (selectionChange)="projectValueChange($event)">
            </kendo-dropdownlist>
            <!-- <kendo-dropdownlist class="ddl" #project_name [data]="projects" formControlName="projectId"
          textField="project_name" valueField="id" (valueChange)="projectValueChange($event)"
          [defaultItem]="defaultProjectItem" [value]="selectedProjectId" [valuePrimitive]="true">
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem.project_name }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem.project_name }}
          </ng-template>
        </kendo-dropdownlist> -->
          </div>
        </div>

      </div>
      <div class="col-6">
        <div class="k-form-field">
          <label for="stories" class="form-label col-3">Stories</label>
          <div class="col-8">
            <kendo-dropdownlist class="ddl" #stories [data]="storyOptions" formControlName="dashboardStr"
              textField="text" valueField="value" [value]="selectedStory" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </div>
        </div>

      </div>

    </div>
    }
    <div class="row">
      <div class="col-6">

        <div class="k-form-field">
          <label class="form-label col-3">Story Type</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #storyType formControlName="userStoryTypeId" [data]="storyTypes"
                    textField="user_story_type_description" valueField="id" [value]="selectedType"
                    [valuePrimitive]="true" (selectionChange)="selectionChange($event)"
                    [defaultItem]="defaultStoryTypeItem">
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      @if(dataItem.iconClass) {
                      <fa-icon class="fa-solid fa-duotone {{dataItem?.iconClass}}"
                        [icon]="['fad', dataItem?.icon]"></fa-icon>
                      }
                      {{ dataItem.user_story_type_description }}
                    </ng-template>
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      <!-- {{dataItem | json}} -->
                      @if(dataItem) {
                      @if(dataItem.iconClass){
                      <fa-icon class="fa-solid fa-duotone {{dataItem.iconClass}}"
                        [icon]="['fad', dataItem.icon]"></fa-icon>
                      }
                      {{ dataItem.user_story_type_description }}
                      }
                    </ng-template>
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>

            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Priority</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <!-- <div>
                user priority id: {{user_story_priority_id_value}}<br>
                user priority: {{user_story_priority_description_value}}
              </div> -->
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #storyPriority id="storyPriority"
                    formControlName="userStoryPriorityId" [data]="storyPriorities"
                    textField="user_story_priority_description" valueField="id" [value]="selectedPriority"
                    [valuePrimitive]="true" [defaultItem]="defaultDropdownItem">
                  </kendo-dropdownlist>
                </div>
              </kendo-formfield>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Project Label</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" formControlName="projectLabelId" [data]="projectLabels"
                    textField="project_label_description" valueField="id" [valuePrimitive]="true"
                    [defaultItem]="defaultDropdownItem">
                  </kendo-dropdownlist>
                </div>
              </kendo-formfield>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Estimate</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <!-- <div>
                user estimate id: {{user_story_estimate_id_value}}<br>
                user estimate: {{user_story_estimate_description_value}}
              </div> -->
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #estimate formControlName="userStoryEstimateId"
                    [data]="storyEstimates" textField="user_story_estimate_description" valueField="id"
                    [value]="selectedPriority" [valuePrimitive]="true" [defaultItem]="defaultDropdownItem">
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Requester</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #requester formControlName="requestedByUserId" [data]="users"
                    textField="fullName" valueField="id" [value]="selectedRequester" [valuePrimitive]="true"
                    [defaultItem]="defaultRequesterItem">
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      @if(dataItem.id){
                      <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                      } @else {
                      <span>{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                      }
                    </ng-template>
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      @if(dataItem.id) {
                      <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                      } @else {

                      }
                    </ng-template>
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>

            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Owners</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <kendo-dropdownlist class="ddl" #owners formControlName="ownedByUserId" [data]="modUsers"
                  textField="fullName" valueField="user_id" [valuePrimitive]="true" [defaultItem]="defaultOwnerItem">
                  <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                  </ng-template>
                  <ng-template kendoDropDownListValueTemplate let-dataItem>
                    @if(dataItem.id){
                    <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                    } @else {
                    {{ dataItem.fullName }}
                    }
                  </ng-template>
                </kendo-dropdownlist>
              </kendo-formfield>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="k-actions k-actions-horizontal k-actions-stretched k-dialog-actions k-window-actions ng-star-inserted">
      <button kendoButton class="btn btn-secondary" (click)="clearForm()">
        Clear Search
      </button>
      <button kendoButton type="submit" (click)="applySearch()" class="btn btn-primary" [disabled]="form.invalid">
        Apply Search
      </button>
    </div>

  </form>

</kendo-expansionpanel>
